let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2wknl")).then(() => parcelRequire('ehvQ6'));